// extracted by mini-css-extract-plugin
export default {"container":"LabelingContainer_container__3Pt1j"};